export default __webpack_public_path__ + "static/media/sound-noti.5b9ecb19.wav";